import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { ReactComponent as Loader } from "../assets/icons/Loader.svg";
import Logo from "../assets/images/IndusindLogo.png";
import CarePlixLogo from "../assets/images/CarePlixLogo.png";

const ValidateReferral = () => {
  const navigate = useNavigate();
  const { setReferralValidated, setAgentInfo: saveAgentInfo } = useAuth();
  const [isLoading, setLoading] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [referralError, setReferralError] = useState("");
  const [agentInfo, setAgentInfo] = useState(null);

  const validateReferralCode = async () => {
    setLoading(true);
    setReferralError("");
    setAgentInfo(null);
    try {
      const trimmed = referralCode.trim().toUpperCase();
      if (trimmed.length === 0) throw new Error("Please enter an Agent Code");
      setReferralCode(trimmed);

      const resp = await fetch("/api/validate-referral", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ referral_code: trimmed }),
      });
      const data = await resp.json();

      if (data.success) {
        setAgentInfo(data.data);
        saveAgentInfo(data.data);
        setTimeout(() => {
          setReferralValidated(true);
          navigate("/", { replace: true });
        }, 1500);
      } else {
        throw new Error(data.message);
      }
    } catch (err) {
      setReferralError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen pt-6 px-6 pb-6 relative bg-white">
      <div className="flex items-center mb-8">
        <img className="h-12" src={Logo} alt="logo" />
        <div className="w-px h-8 bg-gray-300 mx-3" />
        <div className="flex flex-col items-start">
          <span className="text-gray-500 text-xs leading-tight font-medium">Powered by</span>
          <img className="h-5 mt-0.5 object-contain" src={CarePlixLogo} alt="CarePlix" />
        </div>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!isLoading && !agentInfo) validateReferralCode();
        }}
        noValidate
      >
        <h1 className="text-2xl text-primary font-semibold">Validate Agent Code</h1>
        <p className="mt-3 text-darkgray font-light">
          Please enter your agent code to proceed to the dashboard
        </p>

        <input
          type="text"
          id="referral"
          name="referral"
          placeholder="Enter Agent Code"
          autoComplete="off"
          autoFocus
          required
          className={`block w-full mt-6 px-4 py-2 rounded-lg border ${
            referralError.length > 0
              ? "border-error bg-error/5"
              : agentInfo
              ? "border-green-500 bg-green-50"
              : "border-lightgray/20"
          } outline-none focus:border-primary text-primary placeholder:text-lightgray text-sm`}
          onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
          value={referralCode}
          disabled={isLoading || !!agentInfo}
        />
        {referralError.length > 0 && (
          <p className="mt-1.5 text-xxs text-error">{referralError}</p>
        )}

        {agentInfo && (
          <div className="mt-4 p-4 rounded-lg bg-green-50 border border-green-200">
            <p className="text-green-700 text-sm font-medium">Agent Code Validated!</p>
            <div className="mt-2 space-y-1">
              <p className="text-green-600 text-xs">
                <span className="font-medium">Agent:</span> {agentInfo.agent_name}
              </p>
            </div>
            <p className="mt-2 text-green-500 text-xxs">Redirecting to dashboard...</p>
          </div>
        )}

        {!agentInfo && (
          <button
            className="mt-6 w-full flex items-center justify-center space-x-2 rounded-full px-4 py-2 bg-primary disabled:bg-darkgray text-white"
            type="submit"
            disabled={isLoading || referralCode.trim().length === 0}
          >
            <span className="text-sm font-medium">Validate & Proceed</span>
            {isLoading && <Loader className="flex-shrink-0 h-4 w-4" />}
          </button>
        )}
      </form>
      <div className="absolute bottom-6 left-6 right-6">
        <p className="text-xxs text-gray-400 text-justify leading-relaxed">
          <span className="font-semibold text-gray-500">Disclaimer:</span> For Investigational Use Only. Careplix is not a substitute for the clinical judgment of a healthcare professional. Careplix is intended to improve your awareness of general wellness. Careplix does not diagnose, treat, mitigate or prevent any disease, symptom, disorder or abnormal physical state. Consult with a health care professional or emergency services if you believe you may have a medical issue.
        </p>
        <p className="mt-2 text-gray-400 text-left font-semibold leading-relaxed" style={{ fontSize: "0.55rem" }}>
          Indusindinsurance.com | 022 4890 3009 (Paid) | 74004 22200 (WhatsApp)
        </p>
        <p className="mt-1 text-gray-400 text-justify leading-relaxed" style={{ fontSize: "0.55rem" }}>
          T&C Apply. IRDAI Registration No. 103. IndusInd General Insurance Company Limited (Formerly known as Reliance General Insurance Company Limited). An ISO 9001:2015 Certified Company. Registered & Corporate Office: 6th Floor, Oberoi Commerz, International Business Park, Oberoi Garden City, Off. Western Express Highway, Goregaon (E), Mumbai-400063. Corporate Identity Number: U66603MH2000PLC128300.
        </p>
      </div>
    </section>
  );
};

export default ValidateReferral;
